var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSortNone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.13118 15.5693L11.387 17.8251C11.7267 18.1648 12.2754 18.1648 12.6151 17.8251L14.871 15.5693C15.4197 15.0206 15.0278 14.0799 14.2526 14.0799H9.74087C8.9657 14.0799 8.58246 15.0206 9.13118 15.5693Z",
    fill: "#91919A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.13118 8.99798L11.387 6.74213C11.7267 6.40244 12.2754 6.40244 12.6151 6.74213L14.871 8.99798C15.4197 9.5467 15.0278 10.4874 14.2526 10.4874H9.74087C8.9657 10.4874 8.58246 9.5467 9.13118 8.99798Z",
    fill: "#91919A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortNone);
export default __webpack_public_path__ + "static/media/sort-none.02ffb44fed9e3672d7135df001c60bcc.svg";
export { ForwardRef as ReactComponent };